<template>
  <Layout
    :errors="errors"
    :nav-items="aspectMenuItems"
    :title="trans(`models.${resourceType}.content.index.title`)"
    :toasts="toasts"
  >
    <card :title="model.data.attributes.title">
      <div style="font-family: Arial, sans-serif;" class="pt-2">
        <div v-html="model.data.attributes.content"></div>
      </div>
    </card>
  </Layout>
</template>

<script>
import Card from '@/structures/default/components/Base/Card';
import Layout from '@/structures/moviary/Pages/Layout';

export default {
  components: {
    Card,
    Layout,
  },
  props: {
    aspectMenuItems: { type: Object, default: () => {} },
    model: { type: Object, default: () => {} },
    toasts: { type: Object, default: () => {} },
    errors: { type: Object, default: () => {} },
  },
  setup() {

  },
};
</script>
